

/// <reference path="LegalEntityPaymentInstallment.ts" />

// Generated class SupplierPaymentInstallment_ManagedObject

class SupplierPaymentInstallment_ManagedObject extends LegalEntityPaymentInstallment
{
}
